import axios from 'axios'
import qs from 'query-string'

/* eslint-disable */

export function slugify(string) {
    const a =
        'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
    const b =
        'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
    const p = new RegExp(a.split('').join('|'), 'g')

    return string
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, '-and-') // Replace & with 'and'
        .replace(/[^\w\-]+/g, '') // Remove all non-word characters
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '') // Trim - from end of text
}

export const slugString = (slug) => {
    // prevent removing dashes from `one-piece`
    let op
    if (slug.match(/one-piece/)) {
        op = slug.match(/one-piece/)
    } else if (slug.match(/two-piece/)) {
        op = slug.match(/two-piece/)
    } else if (slug.match(/fleece-lined/)) {
        op = slug.match(/fleece-lined/)
    } else if (slug.match(/2-pack/)) {
        op = slug.match(/2-pack/)
    } else if (slug.match(/3-pack/)) {
        op = slug.match(/3-pack/)
    } else if (slug.match(/4-pack/)) {
        op = slug.match(/4-pack/)
    } else if (slug.match(/4-piece/)) {
        op = slug.match(/4-piece/)
    } else if (slug.match(/6-piece/)) {
        op = slug.match(/6-piece/)
    } else if (slug.match(/v-neck/)) {
        op = slug.match(/v-neck/)
    } else if (slug.match(/zip-up/)) {
        op = slug.match(/zip-up/)
    } else if (slug.match(/all-in-one/)) {
        op = slug.match(/all-in-one/)
    } else if (slug.match(/arms-out/)) {
        op = slug.match(/arms-out/)
    } else if (slug.match(/in-person/)) {
        op = slug.match(/in-person/)
    }

    let slugString

    if (op && op.length > 0) {
        let withoutOp
        if (
            op.toString() === '2-pack' ||
            op.toString() === '3-pack' ||
            op.toString() === '4-pack' ||
            op.toString() === '4-piece' ||
            op.toString() === '6-piece' ||
            op.toString() === 'zip-up' ||
            op.toString() === 'arms-out' ||
            op.toString() === 'v-neck' ||
            op.toString() === 'all-in-one' ||
            op.toString() === 'in-person'
        ) {
            withoutOp = slug.split(op)[1]
            // console.log('3-pack op, without op 3-pack', op, withoutOp)
            slugString = op + withoutOp.replace(/-/g, '%20')
        } else {
            op = op[0]
            withoutOp = slug.split(op)[0]
            // console.log('op, without op', op, withoutOp)
            slugString = withoutOp.replace(/-/g, '%20') + op
        }
    } else {
        slugString = slug.replace(/-/g, '%20')
    }

    return slugString
}

export const getFirstProducts = async (queryUrl) => {
    // console.time('query')
    const result = await axios(queryUrl)

    // console.log('result in function', result)
    // console.timeEnd('query')

    return result.data
}

export const getProducts = async (pages, queryUrl) => {
    console.log('in getProducts')
    let result
    let products = []
    let morePagesAvailable = true
    let currentPage = 0

    if (!pages || !queryUrl) {
        return null
    }

    for (let i = 0; i < pages; i++) {
        // console.time('page loop')
        // console.log('currentPage', currentPage)
        currentPage++
        result = await axios(`${queryUrl}&page=${currentPage}`)

        products.push(result.data.products)

        morePagesAvailable = currentPage < pages

        // console.timeEnd('page loop')
    }

    if (products && products.length) {
        return {
            products: products.flat(1),
            data: result.data,
        }
    }
}

export const getNextProducts = async (queryUrl) => {
    console.log('in getNextProducts')
    let result
    let products = []

    result = await axios(queryUrl)

    products.push(result.data.products)

    if (products && products.length) {
        return {
            products: products.flat(1),
            data: result.data,
        }
    }
}

export const getMatchingProducts = async (queryUrl) => {
    console.log('in getNextProducts')
    let result
    let products = []

    result = await axios(queryUrl)

    products.push(result.data.products)

    if (products && products.length) {
        return {
            products: products.flat(1),
            data: result.data,
        }
    }
}

export const getQueriedProducts = async (
    filterObj,
    queryString,
    collectionId
) => {
    const filterType = filterObj.filterType
    const filterValue = filterObj.value
    const filterOption = filterObj.option

    const boostLiveUrl =
        'https://services.mybcapps.com/bc-sf-filter/filter?shop=monicaandandyonline.myshopify.com&limit=70&collection_scope='

    let queryPre = '_'
    let queryPreValue = 'pf'
    let querySize = 'pf_opt_size'
    let queryPrint = 'pf_opt_pattern'
    let queryType = 'pf_pt_product_type'
    let queryGender = 'pf_opt_gender'

    let queryParam
    let queryValue

    if (filterOption === 'opt_size') {
        queryParam = querySize
        queryValue = filterValue
    }
    if (filterOption === 'opt_pattern') {
        queryParam = queryPrint
        queryValue = filterValue
    }
    if (filterOption === 'product_type') {
        queryParam = queryType
        queryValue = filterValue
    }
    if (filterOption === 'opt_gender') {
        queryParam = queryGender
        queryValue = filterValue
    }

    queryString = queryString.replace(/%2520/g, '%20')

    let queryStringReplace = queryString.replace('?', '&')

    let queryUrl = ''
    let clearQueryUrl = ''

    if (queryParam && queryValue) {
        queryParam = queryParam.replace(/ /g, '%20')
        queryValue = queryValue.replace(/ /g, '%20')
        if (queryString) {
            // console.log(
            //     'queryString present, queryString, queryParam, queryValue',
            //     queryString,
            //     queryParam,
            //     queryValue
            // )

            if (queryValue === 'clear') {
                // console.log('clear clicked, filterOption', filterOption)
                removeParam(queryParam)
                clearQueryUrl = `${boostLiveUrl}${collectionId}${queryStringReplace}&${filterType}${filterValue}&build_filter_tree=true`

                let regex = ''

                if (filterOption === 'opt_size') {
                    regex = /&pf_opt_size=[^&]*/
                    // console.log('regex opt_size', regex)
                }
                if (filterOption === 'opt_pattern') {
                    regex = /&pf_opt_pattern=[^&]*/
                }

                if (filterOption === 'product_type') {
                    regex = /&pf_pt_product_type=[^&]*/
                }

                if (filterOption === 'opt_gender') {
                    regex = /&pf_opt_gender=[^&]*/
                }

                clearQueryUrl = clearQueryUrl.replace(regex, '')

                // console.log('clearQueryUrl after clear', clearQueryUrl)

                queryUrl = clearQueryUrl
            } else {
                if (
                    queryString.includes(queryValue) &&
                    queryString.includes(queryValue)
                ) {
                    // console.log(
                    //     'queryParam + value already exists',
                    //     queryParam,
                    //     queryValue
                    // )
                    removeQueryString(queryParam, queryValue)
                } else {
                    // console.log('query string new value')
                    insertUrlParam(queryParam, queryValue)
                }
            }
        } else {
            // console.log('this one')
            if (queryValue !== 'clear') {
                insertParam(queryPre, queryPreValue)
                insertParam(queryParam, queryValue)
            } else {
                // console.log('clear with no query value')
                // we have no active filters; no need to query API
                setIsFiltering(false)

                return
            }
        }
    } else {
        // console.log('no queryParam after click')
    }

    let queryStringAfterClick = window.location.search

    if (!clearQueryUrl) {
        queryUrl = `${boostLiveUrl}${collectionId}${queryStringReplace}&${filterType}${filterValue}&build_filter_tree=true&product_available=true&variant_available=true`
    } else {
        queryUrl = clearQueryUrl
    }

    queryUrl = queryUrl.replace(/pf_opt_size=/g, 'pf_opt_size[]=')
    queryUrl = queryUrl.replace(/pf_opt_pattern=/g, 'pf_opt_pattern[]=')
    queryUrl = queryUrl.replace(/pf_pt_product_type=/g, 'pf_pt_product_type[]=')
    queryUrl = queryUrl.replace(/pf_opt_gender=/g, 'pf_opt_gender[]=')
    queryUrl = queryUrl.replace(/ /g, '%20')
    queryUrl = queryUrl
        .replace('&pf_opt_pattern[]=clear', '')
        .replace('&pf_opt_size[]=clear', '')
        .replace('&pf_opt_gender[]=clear', '')
        .replace('&pf_pt_product_type[]=clear', '')

    // console.log(
    //     'queryUrl sent to Boost, clearQueryUrl',
    //     queryUrl,
    //     clearQueryUrl
    // )

    return await axios(queryUrl)
}

export const getVariantsFromData = (data) => {
    let products = data

    let variants = products.map((p) => {
        return p.variants
    })

    variants = variants.flat(2)

    let productTimes = products.map((p) => {
        // if (p.product_type === 'Bottoms') {
        //     console.log('Bottoms product type', p)
        // }
        return {
            product_id: p.id,
            created_at: p.created_at,
            product_title: p.title,
        }
    })

    // console.log('productTimes', productTimes)

    // we don't have a 'gender' property by default; add it for filtering
    let variantsWithGender = variants.map((v) => {
        let gender
        const options = v.merged_options
        // console.log('options in gender', m, options)
        const genderOption = options.find((o) => o.includes('gender:'))
        if (genderOption) {
            gender = genderOption.split(':')[1]
        }

        // console.log('gender in variants', gender)
        return { ...v, gender: gender ? gender : 'Unisex' }
    })

    let variantsWithTime = []
    variantsWithGender.map((v) => {
        productTimes.map((t) => {
            if (t.product_id === v.product_id) {
                variantsWithTime.push({
                    ...v,
                    product_title: t.product_title,
                    created_at: t.created_at,
                    id_pattern:
                        v.initial_color && v.initial_color.length
                            ? t.product_id + '_' + slugify(v.initial_color)
                            : t.product_id + '_one-color',
                })
            }
            return null
        })
        return null
    })

    let variantsRanked = []

    if (collectionRank && collectionRank.length) {
        variantsWithTime.map((v) => {
            collectionRank.map((r) => {
                // console.log('v, r', v, r)
                // eslint-disable-next-line
                if (v.id == r.id) {
                    variantsRanked.push({
                        ...v,
                        forcerank: r.forcerank ? r.forcerank : 9999999,
                    })
                }
                return null
            })
            return null
        })

        variantsRanked = getUniqueListBy(variantsRanked, 'id')

        variantsRanked.sort(function (a, b) {
            // console.log('a,b', a, b)
            return a.forcerank - b.forcerank
        })
    }

    // console.log('variantsWithTime', variantsWithTime)

    // console.log('variantsWithGender', variantsWithGender)

    let variantsNoRanking = []

    // split out variants with and without rankings so we can sort
    let variantsWithRanking = []

    variantsWithTime.map((v) => {
        v.metafields.map((m) => {
            if (m.key === 'featured' && m.value) {
                // console.log('m with value', m)
                variantsWithRanking.push(v)
            } else {
                variantsNoRanking.push(v)
            }
            return null
        })

        return false
    })

    // console.log('variantsRanked', variantsRanked)

    // console.log('variantsWithForceRanking', variantsWithForceRanking)

    let variantsNoRankingShuffled = getShuffledArray(variantsNoRanking)

    variantsWithRanking.sort(function (a, b) {
        return a.metafields[0]['value'] - b.metafields[0]['value']
    })

    // console.log('variantsWithRanking', variantsWithRanking)

    allVariants = [
        ...variantsRanked,
        ...variantsWithRanking,
        ...variantsNoRankingShuffled,
    ]

    allVariants = [...new Set(allVariants)]

    // console.log('allVariants', allVariants)

    let carroVariants = allVariants.filter((v) => {
        if (v.fulfillment_service && v.fulfillment_service.length) {
            return v.fulfillment_service.indexOf('carro') > -1
        }
        return null
    })

    // console.log('carroVariants', carroVariants)

    carroVariants = getUniqueListBy(carroVariants, 'product_id')

    const variantsWithInventory = allVariants.filter((x) => {
        return x.inventory_quantity > 0
    })

    uniqueVariants = variantsWithInventory.filter(
        (v, i, a) =>
            a.findIndex(
                (t) =>
                    t.product_id === v.product_id &&
                    t.initial_color === v.initial_color
            ) === i
    )

    uniqueVariants = [...uniqueVariants, ...carroVariants]

    // console.log('uniqueVariants', uniqueVariants)

    const queryString = window.location.search

    if (queryString && queryString !== '?_=pf') {
        console.log('query string present')

        // initialize array to hold active filters
        let activeFilters = []

        // use qs library to parse query string
        const parsedQueryString = qs.parse(queryString)

        if (parsedQueryString.pf_opt_size) {
            activeFilters.push({
                type: 'size',
                values: formatQueryStringValues(parsedQueryString.pf_opt_size),
            })
        }

        if (parsedQueryString.pf_opt_pattern) {
            activeFilters.push({
                type: 'print',
                values: formatQueryStringValues(
                    parsedQueryString.pf_opt_pattern
                ),
            })
        }

        if (parsedQueryString.pf_pt_product_type) {
            activeFilters.push({
                type: 'product_type',
                values: formatQueryStringValues(
                    parsedQueryString.pf_pt_product_type
                ),
            })
        }

        if (parsedQueryString.pf_opt_gender) {
            activeFilters.push({
                type: 'gender',
                values: formatQueryStringValues(
                    parsedQueryString.pf_opt_gender
                ),
            })
        }

        // console.log('activeFilters', activeFilters)

        const filteredCollected = () => {
            const collectedTrueKeys = {
                initial_size: [],
                initial_color: [],
                product_type: [],
                gender: [],
            }
            activeFilters.map((s) => {
                if (s.type === 'size') {
                    s.values.map((v) => {
                        collectedTrueKeys.initial_size.push(v)
                        return null
                    })
                }
                if (s.type === 'print') {
                    s.values.map((v) => {
                        collectedTrueKeys.initial_color.push(v)
                        return null
                    })
                }
                if (s.type === 'product_type') {
                    s.values.map((v) => {
                        collectedTrueKeys.product_type.push(v)
                        return null
                    })
                }
                if (s.type === 'gender') {
                    s.values.map((v) => {
                        collectedTrueKeys.gender.push(v)
                        return null
                    })
                }
                return null
            })

            return collectedTrueKeys
        }

        let selectedCollected = filteredCollected()

        let filteredVariants = multiFilter(
            variantsWithInventory,
            selectedCollected,
            queryString
        )

        console.log('filteredVariants', filteredVariants)

        if (filteredVariants && filteredVariants.length) {
            uniqueVariants = getUniqueListBy(filteredVariants, 'id_pattern')
        } else {
            handleClearAll()
        }
    }
}

export function checkIfFileExists(fileToCheck) {
    return new Promise((resolve, reject) => {
        fetch(fileToCheck).then((res) => {
            if (res.status == 404) resolve(false)
            if (res.status == 200) resolve(true)
            return res.text()
        })
    })
}

export const getShuffledArray = (arr) => {
    const newArr = arr.slice()
    for (let i = newArr.length - 1; i > 0; i--) {
        const rand = Math.floor(Math.random() * (i + 1))
        ;[newArr[i], newArr[rand]] = [newArr[rand], newArr[i]]
    }
    return newArr
}

export const getUniqueListBy = (arr, key) => {
    return [...new Map(arr.map((item) => [item[key], item])).values()]
}

export const multiFilter = (variants, filters) => {
    // console.log(
    //     'variants in multiFilter, filters, queryString',
    //     variants,
    //     filters,
    //     queryString
    // )

    const filterKeys = Object.keys(filters)
    // console.log('filterKeys, query', filterKeys, query)

    let filteredVariants = variants.filter((variant) => {
        return filterKeys.every((key) => {
            // console.log('filters[key]', filters[key])
            if (!filters[key].length) return true
            // Loops again if product[key] is an array (for material attribute).
            if (Array.isArray(variant[key])) {
                return variant[key].every((keyEle) =>
                    filters[key].includes(keyEle)
                )
            }

            return filters[key].includes(variant[key])
        })
    })
    // console.log('filteredVariants', filteredVariants)
    return filteredVariants
}

export const nestedFilter = (targetArray, filters) => {
    var filterKeys = Object.keys(filters)
    console.log('filterKeys, filters', filterKeys, filters)
    return targetArray.filter(function (eachObj) {
        return filterKeys.every(function (eachKey) {
            if (!filters[eachKey].length) {
                return true
            }
            return filters[eachKey].includes(eachObj[eachKey])
        })
    })
}

export const dynamicSort = (property) => {
    var sortOrder = 1
    if (property[0] === '-') {
        sortOrder = -1
        property = property.substr(1)
    }
    return function (a, b) {
        /* next line works with strings and numbers,
         * and you may want to customize it to your needs
         */
        var result =
            a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
        return result * sortOrder
    }
}

export const sortByKey = (array, key) => {
    return array.sort(function (a, b) {
        return a[key] - b[key]
    })
}

export const nestedSort = (prop, arr) => {
    prop = prop.split('.')
    var len = prop.length

    arr.sort(function (a, b) {
        var i = 0
        while (i < len) {
            a = a[prop[i]]
            b = b[prop[i]]
            i++
        }
        if (a < b) {
            return -1
        } else if (a > b) {
            return 1
        } else {
            return 0
        }
    })
    return arr
}

export const chunkArray = (array, chunkSize) => {
    // console.log('array in chunked', array)
    // console.log('pageCount', pageCount)
    const perChunk = chunkSize // items per chunk

    const chunked = array.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / perChunk)

        if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = [] // start a new chunk
        }

        resultArray[chunkIndex].push(item)

        return resultArray
    }, [])

    return chunked
}

export const insert = (arr, index, newItem) => [
    // part of the array before the specified index
    ...arr.slice(0, index),
    // inserted item
    newItem,
    // part of the array after the specified index
    ...arr.slice(index)
  ]

export const locationType = () => {
    if (window.location.protocol == 'file:') {
        return 0
    }
    if (!window.location.host.replace(/localhost:3000|127\.0\.0\.1/i, '')) {
        return 2
    }
    return 1
}

export const insertParam = (key: string, value: string) => {
    // key = encodeURIComponent(key)
    // value = encodeURIComponent(value)

    let kvp = window.location.search.substr(1).split('&')
    if (kvp[0] === '') {
        let path =
            window.location.protocol +
            '//' +
            window.location.host +
            window.location.pathname +
            '?' +
            key +
            '=' +
            value
        path = path.replace(/\+/g, '%20')
        window.history.pushState({ path: path }, '', path)
    } else {
        let i = kvp.length
        let x
        while (i--) {
            x = kvp[i].split('=')

            console.log('x[0]', x[0])

            if (x[0] === key) {
                x[1] = value
                kvp[i] = x.join('=')
                // break
            }
        }

        if (i < 0) {
            kvp[kvp.length] = [key, value].join('=')
        }

        let refresh =
            window.location.protocol +
            '//' +
            window.location.host +
            window.location.pathname +
            '?' +
            kvp.join('&')
        refresh = refresh.replace(/\+/g, '%20')
        refresh = refresh.replace(/%2520/g, '%20')
        window.history.pushState({ path: refresh }, '', refresh)
    }
}

export const insertUrlParam = (key, value) => {
    if (history.pushState) {
        let searchParams = new URLSearchParams(window.location.search)
        searchParams.append(key, value)

        let newurl =
            window.location.protocol +
            '//' +
            window.location.host +
            window.location.pathname +
            '?' +
            searchParams
        newurl = newurl.replace(/\+/g, '%20')
        newurl = newurl.replace(/%2520/g, '%20')
        newurl = newurl.replace(/%252F/g, '%2F')
        window.history.pushState({ path: newurl }, '', newurl)
    }
}

export const removeParam = (paramName) => {
    let searchParams = new URLSearchParams(window.location.search)
    searchParams.delete(paramName)
    if (history.replaceState) {
        let searchString =
            searchParams.toString().length > 0
                ? '?' + searchParams.toString()
                : ''
        let newUrl =
            window.location.protocol +
            '//' +
            window.location.host +
            window.location.pathname +
            searchString +
            window.location.hash
        history.replaceState(null, '', newUrl)
    }
}

export const removeQueryString = (key, value, url) => {
    console.log('key, value in updateQS', key, value)
    // TODO: update this to remove ? if no other query string
    if (!url) url = window.location.href

    let stringToRemoveAnd = '&' + key + '=' + value
    let stringToRemoveQ = '?' + key + '=' + value

    let updated = ''

    if (url.includes(stringToRemoveAnd)) {
        updated = url.replace(stringToRemoveAnd, '')
    } else if (url.includes(stringToRemoveQ)) {
        updated = url.replace(stringToRemoveQ, '')
    }

    window.history.replaceState({ path: updated }, '', updated)
}

export const formatQueryStringValues = (data) => {
    let values
    if (Array.isArray(data)) {
        values = data
    } else {
        values = data.split()
    }
    return values
}

export function fileNameAndExt(str) {
    var file = str.substr(0, str.lastIndexOf('/'));
    var fileExt = str.split('/').pop()
    return [
        file,
        fileExt.substr(0, fileExt.lastIndexOf('.')),
        fileExt.substr(fileExt.lastIndexOf('.') + 1, fileExt.length),
    ]
}

// this crashes iOS browsers (Chrome, Safari, FF)
export const getSessionStorageMaxSize = (error) => {
    if (sessionStorage) {
        var max = 10 * 1024 * 1024,
            i = 64,
            string1024 = '',
            string = '',
            // generate a random key
            testKey = 'size-test-' + Math.random().toString(),
            minimalFound = 0,
            error = error || 25e4

        // fill a string with 1024 symbols / bytes
        while (i--) string1024 += 1e16

        i = max / 1024

        // fill a string with 'max' amount of symbols / bytes
        while (i--) string += string1024

        i = max

        // binary search implementation
        while (i > 1) {
            try {
                sessionStorage.setItem(testKey, string.substr(0, i))
                sessionStorage.removeItem(testKey)

                if (minimalFound < i - error) {
                    minimalFound = i
                    i = i * 1.5
                } else break
            } catch (e) {
                sessionStorage.removeItem(testKey)
                i = minimalFound + (i - minimalFound) / 2
            }
        }

        return minimalFound
    }
}

export const SIZES = [
    'Premie',
    'preemie',
    'newborn',
    '0–2Y',
    '0-2Y',
    '0-3m',
    '0–3m',
    '3-6m',
    '3–6m',
    '0-6m',
    '0–6m',
    '6-9m',
    '6–9m',
    '0-12m',
    '0–12m',
    '9-12m',
    '9–12m',
    '6-12m',
    '6–12m',
    '12-18m',
    '12–18m',
    '12-24m',
    '12–24m',
    '18-24m',
    '18–24m',
    '1T',
    '2T',
    '2/3T',
    '2–3T',
    '2-3T',
    '3T',
    '4T',
    '4/5T',
    '4/6Y',
    '5T',
    '6T',
    '6/7',
    '6/8',
    '7/8Y',
    '7–12Y',
    '7-12Y',
    '8',
    '9/10Y',
    '10',
    'XS',
    'XS/S',
    'S',
    'M',
    'M/L',
    'L',
    'L/XL',
    'XL',
    'XXL',
    'Big Kid',
    'Little Kid',
    'Adult',
]

export const FILES_URL = 'https://cdn.shopify.com/s/files/1/2338/2917/files/'

export const getFilteredFilters = (options) => {
    return [...options].map((option) => {
        if (option.filterType === 'opt_gender') {
            option.values = option.values.filter(
                (f) => !f.key.includes('Cash Gift')
            )
        }
        return option
    })
}
